import {Flex, useTheme} from '@chakra-ui/react';
import React from 'react';
import {Partner} from '../../../types/article';
import {H2, TextG10} from '../../../components/typography';
import styled, {css} from 'styled-components';
import {updatePartner} from "../../../endpoints/api";
import {InlineEditableField} from "../../../components/InlineEditableField";
import {ToastMessage} from "../../../components/toast";
import {EntityRole, useGetCurrentUserRoleForEntity} from "../../../hooks/useEntityUserRole";

const StyledFlex = styled(Flex)`
  ${(props) =>
    props.$isPartner &&
    css`
      border-image: linear-gradient(90deg, #e02f84 12.03%, #f9ac39 89.22%);
      border-image-slice: 1;
      border-bottom: 2px solid;
    `};
`;

const Header: React.FC<{partner: Partner, refetchPartner: () => void}> = (props) => {
  const theme = useTheme();

  const { data: currentRole } = useGetCurrentUserRoleForEntity('partners', props.partner.id!);
  const canEditPartner = currentRole?.data === EntityRole.MANAGER || currentRole?.data === EntityRole.TEAM_MEMBER;

  return (
    <StyledFlex
      position="relative"
      top="0"
      width="90%"
      marginLeft="5%"
      transform="auto"
      translateY="-50%"
      marginBottom="-1.5rem"
      backgroundColor="white"
      boxShadow={`0 0 12px ${theme.colors.grey}`}
      borderRadius=".5rem"
      p="0.75rem"
      flexDirection={'column'}>
      <Flex width="100%" justify="space-between">
        <InlineEditableField
          value={props.partner.name}
          canEdit={canEditPartner}
          onSave={(name) => {
            updatePartner(props.partner.id!, { name }).then(() => props.refetchPartner()).catch(e => {
              ToastMessage({
                status: 'error',
                text: e.message
              });
            });
          }}
          renderDisplay={(value) => (
            <H2>{value}</H2>
          )}
        />
      </Flex>
      {props.partner.website && (
        <InlineEditableField
          value={props.partner.website}
          canEdit={canEditPartner}
          onSave={(website) => {
            updatePartner(props.partner.id!, { website }).then(() => props.refetchPartner()).catch(e => {
              ToastMessage({
                status: 'error',
                text: e.message
              });
            });
          }}
          renderDisplay={(value) => (
            <TextG10 color={theme.colors.grey}>{value}</TextG10>
          )}
        />
      )}
    </StyledFlex>
  );
};

export default Header;
